<template>
  <div id="app-alert" :class="{ dangerClass: isDangerClass }">
    <div class="inside-items">
      <div class="circle" v-if="isDangerClass">
        <div class="symbol"></div>
      </div>
      <div class="inside-text" :class="{ dangerClass: isDangerClass }">
        <div v-if="getAlertText(input) !== 'Você deve preencher apenas dados válidos.'">
          <strong>Ops! {{ getAlertText(input) }} inválido.</strong> Revise
          esse campo no seu cadastro da loja para continuar.
        </div>
        <div v-else>
          {{ getAlertText(input)}}
        </div>
      </div>
    </div>
    <div class="icon-close" v-if="closeButton">
      <Icon
        id="close-button-update-modal"
        name="times"
        @click.native="hideAlert"
        class="cursor-pointer"/>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/ui/AppIcon.vue';

export default {
  name: 'AppAlert',
  components: {
    Icon,
  },
  props: {
    input: Array,
    className: String,
    colorType: String,
    getTextFromOptions: Function,
    closeButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getAlertText() {
      return this.getTextFromOptions(this.input) || '';
    },
    hideAlert() {
      const div = document.getElementsByClassName(this.className);
      if (div[0]) {
        div[0].style.display = 'none';
      }
    },
  },
  computed: {
    isDangerClass() {
      return this.colorType === 'danger';
    },
  },
};
</script>

<style lang="scss" scoped>
#app-alert {
  border-radius: 4px;
  margin-bottom: 20px;
  border: 1px solid;
  display: inline-flex;
  width: 100%;
  box-sizing: border-box;
  &.dangerClass{
    background-color: #FBDFDF;
    border-color: #EC6363;
  }
}

.circle {
  height: 20px;
  min-width: 20px;
  background-color: #991B1B;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  margin-top: 1.4px;
}

.symbol {
  background-color: white;
  height: 3px;
  width: 10px;
  position: absolute;
  top: 42%;
  left: 25%;
}

.inside-items {
  padding: 10px;
  display: flex;
  flex-grow: 1;
}

.inside-text {
  display: inline-block;
  text-align: left;
  line-height: 1.4;
  &.dangerClass{
    color: #7F1D1D;
  }
}

.icon-close {
  padding: 10px;
}

</style>
